import React, { useEffect, useState } from "react";
import {
    Form,
    Input,
    Button,
    Typography,
    Row,
    Col,
    DatePicker,
    Spin,
    message,
    Select
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { routes } from "../../../routes/Routes";
import PhoneInput from "react-phone-input-auto-format";
import AlphabetInput from "../../../components/AlphabetInput";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import moment from "moment";
import _AdministratorService from "../../../modules/AdministratorService";

const { Title } = Typography;

const AdministratorPersonalDetails = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const administratorUserId = localStorage.getItem("administratorUserId");
    const [personalInfo, setPersonalInfo] = useState({});
    const [form] = Form.useForm();
    const location = useLocation();

    let data = location.state;
    let consumerIdFromProfile = "";
    let fromDashboard = false;

    if (data && data.administratorUserId) {
        consumerIdFromProfile = data.administratorUserId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    const [administratorFromProfileID] = useState(consumerIdFromProfile);
    const [isFromDashboard] = useState(fromDashboard);

    useEffect(() => form.resetFields(), [personalInfo]);

    useEffect(() => {
        getpersonalDetailsById();
    }, []);

    const onFinish = async (values) => {
        const midadleFirstLetter = values.middleInitial?.charAt(0).toUpperCase();
        try {
            setLoading(true)
            const reqObj = {
                Id: administratorFromProfileID ? administratorFromProfileID : administratorUserId,
                ScreenName: "personaldetails",
                FirstName: values.firstName,
                MiddleInitial: midadleFirstLetter != "" ? midadleFirstLetter : null,
                LastName: values.lastName,
                DateOfBirth: values.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
                ContactNumber: values.contactNumber,
            }
            const res = await _AdministratorService.updateBankerData(reqObj);
            if (res.data.IsSuccess) {
                localStorage.setItem("administratorFirstName", values.firstName);
                setLoading(false);
                if (isFromDashboard) {
                    history.push({ pathname: routes.administratorProfile.path, state: { administratorUserId } });
                } else {
                    history.push(routes.administratorProfessionalDetails.path);
                }
                message.success(res.data.Message)
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    };

    const onBack = () => {
        history.push({ pathname: routes.administratorProfile.path, state: { administratorUserId } });
    };

    const getpersonalDetailsById = async () => {
        setLoading(true);
        try {
            const resObj = await _AdministratorService.getBankerInformationByBankerId(administratorFromProfileID ? administratorFromProfileID : administratorUserId);
            if (resObj.data.Obj) {
                const res = resObj.data.Obj;
                console.log("res", res);
                setPersonalInfo({
                    firstName: res.FirstName,
                    middleInitial: res.MiddleInitial,
                    lastName: res.LastName,
                    dob: res.DateOfBirth ? moment(res.DateOfBirth) : null,
                    contactNumber: res.ContactNumber,
                    email: res.Email
                });
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }

    }

    const disableFutureDates = (current) => {
        return current && current > moment().startOf("day");
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                 <div className="profile-wrapper">
                    <div className="profile-card">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3" }}>
                        Administrator Portal
                    </Title>

                    <Title level={4} style={{ marginBottom: 24 }}>
                        Personal Details
                    </Title>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                        initialValues={personalInfo}
                    >
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8} >
                                <Form.Item
                                    label="First Name"
                                    name="firstName"
                                    rules={[{ required: true, message: "First Name is required" }]}
                                >
                                    <AlphabetInput placeholder="Enter First Name" maxLength={30} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Form.Item
                                    label="Middle Initial"
                                    name="middleInitial"
                                // rules={[
                                //     { required: true, max: 1, message: "Only one character allowed" },
                                // ]}
                                >
                                    <AlphabetInput placeholder="Enter Middle Initial" maxLength={1} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Form.Item
                                    label="Last Name"
                                    name="lastName"
                                    rules={[{ required: true, message: "Last Name is required" }]}
                                >
                                    <AlphabetInput placeholder="Enter Last Name" maxLength={30} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>

                        <Form.Item
                            label="Date Of Birth"
                            name="dob"
                            
                            rules={[{ required: true, message: "Date Of Birth is required" }]}
                        >
                            <DatePicker
                                allowClear
                                inputReadOnly={false}
                                style={{ width: "100%" }}
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                disabledDate={(current) => {
                                    return current && current >= moment().startOf("day");
                                }}
                            />
                        </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>

                        <Form.Item
                            label="Contact Number"
                            name="contactNumber"
                            rules={[
                                { required: true, message: "Contact Number is required" },
                                {
                                    validator: (_, value) => {
                                        if (!value) {
                                            return Promise.resolve(); //  Allow empty value if not required
                                        }
                                        const digits = value.replace(/\D/g, '');
                                        if (digits.length === 10) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                        );
                                    },
                                }
                            ]}
                        >
                            <PhoneInput
                                placeholder="Enter Contact Number"
                                inputComponent={Input}
                                autoComplete="off"
                                onChange={(value) => {
                                    // Remove non-digit characters and store the raw number
                                    const digits = value.replace(/\D/g, '');
                                    form.setFieldsValue({ contactNumber: digits });
                                }}
                            />
                        </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: false, message: "Email address is required" },
                                {
                                    type: "email",
                                    message: "Please enter a valid email address",
                                },
                            ]}
                            
                        >
                            <Input
                                placeholder="Enter Email"
                                maxLength={50}
                                disabled
                            />
                        </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <Form.Item>
                            <div className="w95" style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 20 }}>
                                {isFromDashboard &&
                                    <Button
                                        onClick={onBack}
                                        icon={<LeftOutlined />}
                                    >
                                        Go Back
                                    </Button>
                                }
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default AdministratorPersonalDetails;